import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'
import Helmet from 'react-helmet'

import Section from '../components/section/Section'
import SectionHeader from '../components/section/SectionHeader'
import Button from '../components/buttons/Button'
import { TwoCol, LeftCol, RightCol, } from '../components/two-col'
import SubHeader from '../components/section/SubHeader'
import CalloutContainer from '../components/CalloutContainer'
import HubspotFormSection from '../components/forms/HubspotFormSection'
import TestimonialList from '../components/TestimonialsList'

import heroImg from '../assets/testimonials/testimonials-hero.png'
import headshot1 from '../assets/testimonials/testimonial-headshot-1.png'
import headshot2 from '../assets/testimonials/testimonial-headshot-2.png'
import headshot3 from '../assets/testimonials/testimonial-headshot-3.png'
import headshot4 from '../assets/testimonials/testimonial-headshot-4.png'
import headshot5 from '../assets/testimonials/testimonial-headshot-5.png'
import headshot6 from '../assets/testimonials/testimonial-headshot-6.png'
import headshot7 from '../assets/testimonials/testimonial-headshot-7.png'
import headshot8 from '../assets/testimonials/testimonial-headshot-8.png'
import headshot9 from '../assets/testimonials/testimonial-headshot-9.png'
import seoHero from '../assets/testimonials/seo-hero.png'


const testimonials = [
  {
    image: headshot1,
    title: '5 Star Reviews',
    body: 'Whistle has helped us provide exemplary customer service. Our reputation management has become a breeze with Whistle’s ability to generate 5 star reviews on TripAdvisor.',
    author: 'Braden Conn | Co-Owner',
    hotel: 'BERLIN ENCORE HOTEL'
  },
  {
    image: headshot2,
    title: 'Whistle for the Win!!',
    body: 'I absolutely love how Whistle has enabled us to take our guest service to another level while allowing our team to multi-task and get really creative with our guest interactions.',
    author: 'Ravan Lemoine | Director of Front Officer',
    hotel: 'HAMPTON INN & SUITES DENVER'
  },
  {
    image: headshot3,
    title: 'Very Impressed',
    body: 'We have seen an increase in guest and staff interaction—resulting in increased Customer Service Scores. Our staff has also find Whistle to be extremely helpful in streamlining communication.',
    author: 'Jim Johnson | Director of Operations',
    hotel: 'OJAI HOSPITALITY GROUP'
  },
  {
    image: headshot4,
    title: 'Overwhelming Success!',
    body: 'As a small, boutique hotel our front desk offers limited hours of availability and now we can quickly establish a direct, personal contact with our guests beginning within minutes after booking.',
    author: 'Topher Swanson | Co-Owner',
    hotel: 'THE FRED HOTEL'
  },
  {
    image: headshot5,
    title: 'Experiences vs Logistics',
    body: 'The platform gives our guests the opportunity to focus on the culture and heritage of New Mexico rather than the logistics of their stay.',
    author: 'Adrian Perez | President',
    hotel: 'HERITAGE HOTELS AND RESORTS'
  },
  {
    image: headshot6,
    title: 'A Seamless Integration',
    body: 'Whistle pulls guest information right from our PMS and have it side by side with their messages. Now, we\'re scheduling custom, automated messages to guests at the right time with the right information!',
    author: 'Kerri Coughlin | Guest Service Director',
    hotel: 'LOCALE'
  },
  {
    image: headshot7,
    title: 'Truly Valuable Addition',
    body: 'The Whistle team has been fully engaged with our team from start to finish. Our guests are enjoying the instant access to communicate so easily with our team.',
    author: 'Adrian Montoya | General Manager',
    hotel: 'HOTEL ALBUQUERQUE AT OLD TOWN'
  },
  {
    image: headshot8,
    title: 'Outstanding Results',
    body: 'You can see by our guests\' responses that they felt engaged and appreciated. We actually improved our overall guest service scores by 13.8% over a 2-month period after rolling out Whistle!',
    author: 'Mitchell Hirschman | General Manager',
    hotel: 'HILTON GARDEN INN GARDEN GROVE'
  },
  {
    image: headshot9,
    title: '#1 Communication Tool!',
    body: 'We absolutely love Whistle! It\'s our most important communication tool! We have come to rely on the valuable time-saving service and don’t know how we ever survived without it.',
    author: 'Alisa Armstrong | CEO',
    hotel: 'BIG BEAR COOL CABINS'
  }
]


class TestimonialsPage extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div>
        <Helmet
          title={'Whistle Reviews'}
          meta={[
            { name: 'og:title', content: 'Whistle Reviews' },
            { name: 'description', content: 'No.1 Rating from real customers with real results.' },
            { name: 'og:description', content: 'No.1 Rating from real customers with real results.' },
            { name: 'og:image', content: seoHero },
            { name: 'og:type', content: "website" },
            { name: 'og:locale', content: "en_US" },
          ]}
        >
          <script type="application/ld+json">{`
            {
              "@context": "https://schema.org",
              "@type": "SoftwareApplication",
              "name": "Whistle Messaging",
              "applicationCategory": "BusinessApplication",
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "5.0",
                "ratingCount": "8864"
              },
              "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
              }
            }
          `}</script>
        </Helmet>
        <TwoCol >
          <LeftCol bgColor={'#18aa7a'} skew color="#fff">
            <h1>PROOF FROM<br/> FELLOW<br/> PROPERTIES</h1>
            <SubHeader>It's our great pleasure to be your<br/> Guest Messaging partner.</SubHeader>
            <CalloutContainer align={'left'}>
              <Button secondary to="/schedule" icon>Book A Demo</Button>
            </CalloutContainer>
          </LeftCol>
          <RightCol image bgImgSrc={heroImg} />
        </TwoCol>
      <Section light>
        <SectionHeader align="center">Testimonials</SectionHeader>
        <TestimonialList testimonials={testimonials} /> 
      </Section>
        
      <HubspotFormSection
        id="book-demo"
        formId="7d86c04f-e98e-42eb-ae79-ff2b14c7605a"
        trackingId={process.env.ADWORDS_TRACKER_LEAD_FORM}
      />
    </div>
    )
  }
}

 
export default TestimonialsPage;


// WEBPACK FOOTER //
// ./src/pages/testimonials.js